import { Controller } from "@hotwired/stimulus"

// data-controller="slug"
//   <input data-slug-target="source" data-action="input->slug#update">
//   <input data-slug-target="slug">
//
// Auto-derives slug from source. Stops if the user manually edits the
// slug field — once they've typed a custom value we don't overwrite it.
export default class extends Controller {
  static targets = ["source", "slug"]

  connect() {
    this.locked = this.slugTarget.value.length > 0 &&
                  this.slugTarget.value !== this.slugify(this.sourceTarget.value)
    this.slugTarget.addEventListener("input", () => { this.locked = true })
  }

  update() {
    if (this.locked) return
    this.slugTarget.value = this.slugify(this.sourceTarget.value)
  }

  slugify(str) {
    return (str || "")
      .toString()
      .normalize("NFKD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 60)
  }
}
